/*
Sohel 03/03/2023 2699823790 Added Event Trigger validate popup
*/
import React from 'react';
import {Button, makeStyles, Typography} from '@material-ui/core';
import reusableInputStyles from '../../../../components/InputStyles';
import {useSelector, useDispatch} from 'react-redux';
import {fetchEventTriggerGroup} from '../../../../redux/reducers/EventTriggerGroup';
const useStyles = makeStyles((theme) => ({
  'link': {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));
function AttachedValidationPopup({handleValidationClose}) {
  const {triggerGroupCode} = useSelector(({eventTriggerGroup}) => eventTriggerGroup);
  const classes = reusableInputStyles();
  const classes1 = useStyles();
  const dispatch = useDispatch();
  return (
    <div>
      <div className={classes.dialoguecardStyles}>
        <div className="text-center my-3">
          <Typography variant="h4">
            {' '}
            Event type and Value combination  has already been used in the{' '}
            <span
              role="button"
              className={classes1.link}
              onClick={() => {
                dispatch(fetchEventTriggerGroup(triggerGroupCode));
                setTimeout(() => {
                  handleValidationClose();
                }, 1000);
              }}
            >
              {triggerGroupCode}
            </span>{' '}
            Event Trigger{' '}
          </Typography>
        </div>
        <div className="button-table-spacing-mb">
          <Button
            type="button"
            variant="outlined"
            className={`ml-1 reset-btn`}
            onClick={() => {
              handleValidationClose();
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
export default AttachedValidationPopup;
